import React from 'react';
import { AspectRatio as AspectRatioLib } from 'react-aspect-ratio';
import { AspectRatioStyled } from './styled';
export function AspectRatio(props) {
    const { ratio, children } = props;
    return (React.createElement(AspectRatioStyled, null,
        React.createElement(AspectRatioLib, { ratio: ratio }, children)));
}
AspectRatio.displayName = 'AspectRatio_Component';
